export const accountCoaColumns = [
  { key: 'codeLevel1', text: 'Code Level 1', width: '5%' },
  { key: 'titleLevel1', text: 'Title Level 1', width: '5%' },
  { key: 'codeLevel2', text: 'Code Level 2', width: '5%' },
  { key: 'titleLevel2', text: 'Title Level 2', width: '5%' },
  { key: 'codeLevel3', text: 'Code Level 3', width: '5%' },
  { key: 'titleLevel3', text: 'Title Level 3', width: '5%' },
  { key: 'codeLevel4', text: 'Code Level 4', width: '5%' },
  { key: 'titleLevel4', text: 'Title Level 4', width: '5%' },
  { key: 'codeLevel5', text: 'Code Level 5', width: '5%' },
  { key: 'titleLevel5', text: 'Title Level 5', width: '5%' }
];
